import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

/*
  Generated class for the StorageWraperProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StorageWraperProvider {
  constructor(public http: HttpClient) {}

  set(key, value): void {
    if (!key || !value) {
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string): string {
    var value = JSON.parse(localStorage.getItem(key));
    if (!value) {
      return 'No value found for the give key';
    }
    return value;
  }
  remove(key): void {
    localStorage.removeItem(key);
  }
  getLenght(): number {
    return localStorage.length;
  }
  clear(): void {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/providers/storage-wraper/storage-wraper.ts